import { render, staticRenderFns } from "./EmptyTag.vue?vue&type=template&id=991a2ea4&"
import script from "./EmptyTag.vue?vue&type=script&lang=js&"
export * from "./EmptyTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports